export const RESET = 'subsellerSearch/RESET';
export const SAVE_RESULTS = 'subsellerSearch/SAVE_RESULTS';
export const APPEND_RESULTS = 'subsellerSearch/APPEND_RESULTS';
